// @flow
import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { withTranslation, WithTranslation } from 'react-i18next';
import Modal from 'react-modal';

import { isStaging, isDevelopment } from './utils/utils';
import { getRouteTFunction } from './i18n';

import UserCreate from './components/pages/user-create';
import Home from './components/pages/home';
import Login from './components/pages/login';
import Dashboard from './components/pages/dashboard';
import DashboardShared from './components/pages/dashboard-shared';
import Record from './components/pages/record';
import ResourceViewer from './components/resource-viewer';
import ForgotPassword from './components/pages/forgot-password';
import UpdatePassword from './components/pages/update-password';
import UserProfile from './components/pages/user-profile';
import MyProviders from './components/pages/my-providers';
import VerifyEmail from './components/pages/verify-email';
import AggregatedResource from './components/shared/AggregatedResource';
import FourOFour from './components/pages/404';
import Connections from './components/pages/integrations';
import PatternLibrary from './components/pages/pattern-library';
import RecordShareVerify from './components/pages/record-share-verify';
import RecordShareCreate from './components/pages/record-share-create';
import MapleLogin from './components/pages/maple-login';
import CaredoveLogin from './components/pages/caredove-login';
import IntegrationNoRecords from './components/pages/integration-no-records';
import MobileApps from './components/pages/mobile-apps';
import ToastNotification from './components/toast';
import AuthorizeRequest from './components/pages/authorize-request';
import UserPassport from './components/pages/user-passport';

import PrivateComponent from './components/shared/PrivateComponent';

import history from './history';
import GA from './utils/google-analytics';

type AppProps = WithTranslation;

class App extends Component<AppProps> {
  render() {
    // eslint-disable-next-line react/prop-types
    const { tReady } = this.props;
    const t = getRouteTFunction();

    if (!tReady) return null;

    return (
      <div>
        <ToastNotification containerId='all' />
        <Router history={history}>
          <div className='main'>
            {GA.init() && <GA.RouteTracker />}
            <Switch>
              {/* shared resources routes */}
              <Route exact path={t('routerPaths./shared/:token')} component={RecordShareVerify} />
              <Route
                exact
                path={t('routerPaths./shared/:token/dashboard')}
                component={DashboardShared}
              />
              <Route
                exact
                path={t('routerPaths./shared/:token/resource/:id')}
                component={Record}
              />
              <Route
                exact
                path={t('routerPaths./shared/:token/resource/:id/file/:fileID')}
                component={ResourceViewer}
              />
              {/* regular routes */}
              <Route exact path='/' component={Home} />
              {(isStaging || isDevelopment) && <Route path='/pattern-library' component={PatternLibrary} />}
              <Route exact path={t('routerPaths./apps')} component={MobileApps} />
              <Route path={t('routerPaths./signup')} component={Login} />
              <Route exact path={t('routerPaths./login')} component={Login} />
              <Route exact path={t('routerPaths./verify/:token')} component={VerifyEmail} />
              <Route exact path={t('routerPaths./forgot-password')} component={ForgotPassword} />
              <Route
                exact
                path={t('routerPaths./update-password/:token')}
                component={UpdatePassword}
              />
              <Route path={t('routerPaths./dashboard')} component={PrivateComponent(Dashboard)} />
              <Route path={t('routerPaths./user/info')} component={UserCreate} />
              <Route
                exact
                path={t('routerPaths./profile/integrations')}
                component={PrivateComponent(Connections)}
              />
              <Route
                exact
                path={t('routerPaths./providers')}
                component={PrivateComponent(MyProviders)}
              />
              <Route
                exact
                path={t('routerPaths./profile')}
                component={PrivateComponent(UserProfile)}
              />
              <Route
                exact
                path={t('routerPaths./integrations/maple/incoming')}
                component={MapleLogin}
              />
              <Route
                exact
                path={t('routerPaths./integrations/caredove/incoming')}
                component={CaredoveLogin}
              />
              <Route
                path={t('routerPaths./resource/immunization')}
                component={PrivateComponent(AggregatedResource)}
              />
              <Route path={t('routerPaths./resource/:id')} component={PrivateComponent(Record)} />
              <Route
                path={t('routerPaths./integrations/maple/no-records')}
                component={IntegrationNoRecords}
              />
              <Route path={t('routerPaths./share-records')} component={RecordShareCreate} />
              <Route path={t('routerPaths./404')} component={FourOFour} />
              <Route
                exact
                path={t('routerPaths./requests/:token/authorize')}
                component={AuthorizeRequest}
              />
              <Route exact path={t('routerPaths./passport')} component={UserPassport} />{' '}
              {/* Public route */}
            </Switch>
          </div>
        </Router>
      </div>
    );
  }
}

export default withTranslation(['routes', 'errors', 'passwordFeedback'])(App);

Modal.setAppElement('body');



// WEBPACK FOOTER //
// ./src/app.js